var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1049_11224)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 150,
    height: 150,
    rx: 75,
    fill: "#FA4D4D",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.504 41.8079C110.328 40.9363 111.319 40.2388 112.417 39.7567C113.516 39.2746 114.7 39.0176 115.9 39.0009C117.099 38.9842 118.29 39.2082 119.402 39.6596C120.513 40.1109 121.523 40.7806 122.371 41.6289C123.219 42.4773 123.889 43.487 124.34 44.5986C124.792 45.7102 125.016 46.9009 124.999 48.1005C124.982 49.3001 124.725 50.4842 124.243 51.5828C123.761 52.6814 123.064 53.6721 122.192 54.4965L95.8938 80.7954C95.859 80.8301 95.8313 80.8714 95.8125 80.9168C95.7936 80.9623 95.7839 81.011 95.7839 81.0602C95.7839 81.1093 95.7936 81.1581 95.8125 81.2035C95.8313 81.2489 95.859 81.2902 95.8938 81.3249L122.192 107.624C123.037 108.455 123.709 109.445 124.169 110.536C124.629 111.628 124.869 112.8 124.874 113.985C124.879 115.17 124.649 116.344 124.198 117.44C123.747 118.535 123.083 119.531 122.246 120.369C121.408 121.207 120.413 121.87 119.317 122.322C118.222 122.773 117.047 123.003 115.863 122.998C114.678 122.994 113.506 122.755 112.414 122.295C111.322 121.835 110.332 121.163 109.501 120.318L83.2024 94.0196C83.1676 93.9848 83.1264 93.9571 83.0809 93.9383C83.0355 93.9194 82.9868 93.9097 82.9376 93.9097C82.8884 93.9097 82.8397 93.9194 82.7943 93.9383C82.7488 93.9571 82.7076 93.9848 82.6728 94.0196L56.3744 120.318C55.5436 121.163 54.5537 121.835 53.4619 122.295C52.3701 122.755 51.198 122.995 50.0132 123C48.8283 123.005 47.6542 122.775 46.5586 122.324C45.463 121.873 44.4675 121.21 43.6296 120.372C42.7917 119.534 42.128 118.539 41.6767 117.443C41.2253 116.348 40.9954 115.174 41.0001 113.989C41.0048 112.804 41.244 111.632 41.7039 110.54C42.1639 109.448 42.8355 108.458 43.68 107.627L69.9784 81.3279C70.0132 81.2932 70.0408 81.2519 70.0597 81.2065C70.0786 81.161 70.0883 81.1123 70.0883 81.0631C70.0883 81.014 70.0786 80.9652 70.0597 80.9198C70.0408 80.8744 70.0132 80.8331 69.9784 80.7984L43.68 54.4995C42.0192 52.8118 41.0926 50.5362 41.1019 48.1684C41.1113 45.8006 42.0559 43.5324 43.73 41.8578C45.4041 40.1833 47.672 39.2382 50.0398 39.2282C52.4076 39.2183 54.6834 40.1444 56.3714 41.8049L82.6698 68.1037C82.7046 68.1385 82.7458 68.1662 82.7913 68.185C82.8367 68.2039 82.8854 68.2136 82.9346 68.2136C82.9838 68.2136 83.0325 68.2039 83.0779 68.185C83.1234 68.1662 83.1646 68.1385 83.1994 68.1037L109.498 41.8049L109.504 41.8079Z",
    fill: "#F6FFFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1049_11224",
    x: 0,
    y: 0,
    width: 174,
    height: 174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1049_11224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1049_11224",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCrossIcon);
export default __webpack_public_path__ + "static/media/errorCrossIcon.591d2b09a9d3c7329262f7e7b9c96656.svg";
export { ForwardRef as ReactComponent };